/* Copyright 2023 (Unpublished) Verto Inc. */

import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { CurrentUserService } from '../../services/root-services/current-user.service';
import { TimeZoneService } from '@root/services/timezone.service';
import { InputSwitchModule } from 'primeng/inputswitch';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  timezoneOptions: { name: string; value: string }[];
  selectedTimezone: { name: string; value: string };

  currentUrl: string;
  checked: boolean;
  constructor(
    public currentUser: CurrentUserService,
    private router: Router,
    private timeZoneService: TimeZoneService
  ) {
    this.timezoneOptions = timeZoneService.getTimezoneOptions();
    const tz = timeZoneService.getStoredTimezone();
    this.selectedTimezone = { name: tz, value: tz };
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.currentUrl = event.url;
      }
    });

    this.checked = document.body.classList.contains('dark');
  }

  onTimezoneSelectionChange() {
    this.timeZoneService.timezoneChange(this.selectedTimezone.value);
  }

  logout(): void {
    this.currentUser.logout();
    this.router.navigate(['/login']);
  }

  toggleDarkMode() {
    (window as any).northVertoIsBestVerto();
  }
}
